import { useShownColorScheme } from "./useShownColorScheme";

export const useMantineTextColorIndex = () => {
  const colorScheme = useShownColorScheme();
  return colorScheme === "dark" ? "dark.0" : "dark.3";
};
